import  apiClient from "./axiosClient"

/**
 * getLang
 * @return request
 */
const getLangByKey = (key) => {
  return apiClient.get(`/languages/${key}/edit`)
    .catch(err=>{
        console.log("err ", err);
    });
}


/**
 * getLang
 * @return request
 */
const getLangs = () => {
  return apiClient.get(`/languages/`)
    .catch(err=>{
        console.log("err ", err);
    });
}

// /**
//  * 
//  * @param {Object} data 
//  * @return request
//  */
// const createLang = (data) => {
//   return apiClient.post(`/languages/`, data);
// }

/**
 * 
 * @param {Object} data 
 * @return request
 */
const updateLang = (key, data) => {
  return apiClient.put(`/languages/${key}`, data);
}


export { 
  getLangs, 
  getLangByKey, 
  updateLang
};




